<template>
  <div class="event-detail">
    <div v-if="loaded && workshop">
      <o-card :title="''">
        <div class="card-header px-0 pt-0 pb-3 row">
          <div class="col text-left">
            <img src="/images/termine.svg"/>
            <o-button class="back-text" variant="link" @click.prevent="back">
              <span>{{ $t('medtastic.back_to_overview') }}</span>
            </o-button>
          </div>
        </div>
        <div v-if="workshop" class="upcoming-events">
          <b class="workshop-title">{{ workshop.title }}</b>

          <div class="row">
            <div class="col-12" :class="{ 'col-md-4': workshop.credits, 'col-md-6': !workshop.credits }">
              <div class="mt-4 d-flex">
                <div class="icon-calendar"><img src="/images/calendar.svg"/></div>
                <div class="calendar-text">
                  {{ workshop.date|formatDay }} {{ workshop.date|formatDate }},
                  <br class="d-block d-sm-none">
                  {{ workshop.time|formatTimeString }}-{{ workshop.end_time|formatTimeString }}
                  <template v-if="workshop.with_apero"><br> {{ $t("medtastic.apero_text")}}  </template>
                </div>
              </div>
            </div>
            <div class="col-12" :class="{ 'col-md-4': workshop.credits, 'col-md-6': !workshop.credits }">
              <div class="mt-4 d-flex">
                <div class="icon-location"><img src="/images/location.svg"/></div>
                <div class="location-text"><span v-html="workshop.location"></span>, {{ workshop.region }}</div>
              </div>
            </div>
            <div class="col-12" v-if="workshop.credits" :class="{ 'col-md-4': workshop.credits, 'col-md-6': !workshop.credits }">
              <div class="mt-4 d-flex">
                <div class="icon-location"><img src="/images/credits.svg"/></div>
                <div class="location-text">{{ workshop.credits }}</div>
              </div>
            </div>
          </div>

          <template v-if="workshop.signup_active">
            <br>
            <div class="row">
              <div class="col text-center text-sm-left">
                <router-link :to="{ name: 'medtastic.event_registration', params: {id: workshop.id} }"
                             class="btn btn-dark">
                  {{ $t('medtastic.register_now') }}
                </router-link>
              </div>
            </div>
          </template>
        </div>
        <br>

        <template v-if="workshop.description">
          <div class="row">
            <div class="col greeting-text">
              {{ $t('medtastic.event_greeting') }}
            </div>
          </div>
          <br>
          <div class="row text-description">
            <div class="col">
              <p class="pre-formatted" v-html="workshop.description_with_speaker"></p>
            </div>
          </div>
          <br>
        </template>

        <template
            v-if="workshop.speaker_1 || workshop.speaker_2 || workshop.speaker_3 || workshop.speaker_4 || workshop.speaker_5">
          <div class="row">
            <div class="col speaker-text">
              {{ $t('medtastic.speakers') }}
            </div>
          </div>
          <br>
          <div class="row speaker-list">
            <div v-if="workshop.speaker_1" class="col-6 col-sm-4 col-lg-4 col-xl-3 col-md-3 mb-5">
              <div class="speaker-content mb-3">
                <div class="mt-2">{{ workshop.speaker_1 }}</div>
                <div class="mt-2 font-weight-normal" v-if="workshop.speaker_1_institution">
                  {{ workshop.speaker_1_institution }}
                </div>
              </div>
            </div>
            <div v-if="workshop.speaker_2" class="col-6 col-sm-4 col-lg-4 col-xl-3 col-md-3 mb-5">
              <div class="speaker-content mb-3">
                <div class="mt-2">{{ workshop.speaker_2 }}</div>
                <div class="mt-2 font-weight-normal" v-if="workshop.speaker_1_institution">
                  {{ workshop.speaker_2_institution }}
                </div>
              </div>
            </div>
            <div v-if="workshop.speaker_3" class="col-6 col-sm-4 col-lg-4 col-xl-3 col-md-3 mb-5">
              <div class="speaker-content mb-3">
                <div class="mt-2">{{ workshop.speaker_3 }}</div>
                <div class="mt-2 font-weight-normal" v-if="workshop.speaker_3_institution">
                  {{ workshop.speaker_3_institution }}
                </div>
              </div>
            </div>
            <div v-if="workshop.speaker_4" class="col-6 col-sm-4 col-lg-4 col-xl-3 col-md-3 mb-5">
              <div class="speaker-content mb-3">
                <div class="mt-2">{{ workshop.speaker_4 }}</div>
                <div class="mt-2 font-weight-normal"  v-if="workshop.speaker_4_institution">
                  {{ workshop.speaker_4_institution }}
                </div>
              </div>
            </div>
            <div v-if="workshop.speaker_5" class="col-6 col-sm-4 col-lg-4 col-xl-3 col-md-3 mb-5">
              <div class="speaker-content mb-3">
                <div class="mt-2">{{ workshop.speaker_5 }}</div>
                <div class="mt-2 font-weight-normal" v-if="workshop.speaker_5_institution">
                  {{ workshop.speaker_5_institution }}
                </div>
              </div>
            </div>
          </div>
          <br>
        </template>

        <template v-if="workshop.agenda">
          <div class="row">
            <div class="col agenda-text">
              {{ $t('medtastic.agenda') }}
            </div>
          </div>
          <br>
          <div class="agenda-table table-responsive">
            <div v-html="workshop.agenda"></div>
          </div>
          <br>
        </template>

        <template v-if="workshop.signup_active">
          <div class="row">
            <div class="col text-center btn-registration">
              <router-link :to="{ name: 'medtastic.event_registration', params: {id: workshop.id} }"
                           class="btn btn-dark">
                {{ $t('medtastic.register_now') }}
              </router-link>
            </div>
          </div>
          <br><br>
        </template>
      </o-card>
    </div>
    <div v-if="loaded && !workshop">
      <o-card :shadow="false" :title="$t('core.page_not_found')" class="col-lg-8">
        <router-link class="btn btn-primary" to="/">
          {{ $t('medtastic.back_to_home') }}
        </router-link>
      </o-card>
    </div>
    <div v-if="!loaded">
      <div class="btn-loading">&nbsp;<br>&nbsp;<br>&nbsp;</div>
    </div>
  </div>
</template>

<script>
import axios from 'axios'

export default {
  layout: 'user',
  data () {
    return {
      loaded: false,
      workshop: null,
      workshop_locale: window.config.workshop_locale,
      mainProps: { blank: false, blankColor: '#D5D5D5', width: 122, height: 122, class: 'm1' }
    }
  },
  mounted () {
    this.workshopDetail()
  },
  methods: {
    workshopDetail: function () {
      axios.get('/api/medtastic/workshops/public?include=sponsor_checkboxes,sponsors.sponsor.sponsor_checkboxes&filter%5Bid%5D=' + this.$route.params.id)
          .then((response) => {
            this.workshop = response.data.data[0]
            document.title = this.workshop.title + ' – ' + window.config.appName
            this.loaded = true
          })
          .catch((error) => {
            console.log(error)
            this.loaded = true
          })
    },
    downloadPDF (workshop) {
      var fileName = workshop.pdf_document['name']
      axios.post('/api/medtastic/workshop/downloadPDF', { id: workshop.id }, { responseType: 'arraybuffer' })
          .then((response) => {
            require('downloadjs')(
                response.data,
                fileName,
                'application/pdf'
            )
          }).catch((error) => {
        console.log(error)
      })
    },
    back () {
      this.$router.back()
    }
  }
}
</script>

<style>
@media (min-width: 1200px) {
  .pre-formatted {
    -webkit-column-count: 2;
    -moz-column-count: 2;
    column-count: 2;
    -webkit-column-gap: 3em;
    -moz-column-gap: 3em;
    column-gap: 3em;
  }
}

@media (min-width: 600px) and (max-width: 1200px) {
  .pre-formatted {
    -webkit-column-count: 1;
    -moz-column-count: 1;
    column-count: 1;
    -webkit-column-gap: 3em;
    -moz-column-gap: 3em;
    column-gap: 3em;
  }
}

@media (max-width: 600px) {
  .pre-formatted {
    -webkit-column-count: 1;
    -moz-column-count: 1;
    column-count: 1;
    -webkit-column-gap: 3em;
    -moz-column-gap: 3em;
    column-gap: 3em;
  }
}
</style>
